import * as Sentry from '@sentry/vue'
import appEnv from '@/support/env'

const useErrorLogger = (router: any, dsn: string | null, app: any) => {
  if (dsn && dsn.length) {
    // Initialize Sentry with the app instance
    Sentry.init({
      app, // Pass the Vue app instance here
      dsn: dsn,
      environment: appEnv.ENV || 'beta',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
          levels: ['error']
        })
      ],
      tracesSampleRate: 0.1, // Set sample rate for performance monitoring
      replaysSessionSampleRate: 0.1, // Capture Replay for 10% of all sessions
      replaysOnErrorSampleRate: 1.0, // Capture Replay for 100% of sessions with an error
      // Filter out noisy errors from browser extensions (AdBlockers, etc.)
      denyUrls: [/^chrome-extension:\/\//i]
    })
  }
}

export default useErrorLogger
